import clsx from 'clsx';
import { useToggle } from 'react-use';

import { SidebarCategoryIsActive } from '@/lib/models/Sidebar';
import { ArticleItemSidebar } from '@/shared/ArticleItem/ArticleItemSidebar';

import { HeaderWithArrow } from './HeaderWithArrow';
import styles from './CategoryItem.module.scss';

interface CategoryItemProps {
  category: SidebarCategoryIsActive;
  type: string;
  baseUrl: string;
  activeSlug: string[];
  level: number;
}

export function CategoryItem({ category, activeSlug, baseUrl, level, type }: CategoryItemProps) {
  const [isOpen, toggleCategory] = useToggle(category.isActive);

  const url = `${baseUrl}/${category.slug}`;

  return (
    <div
      className={clsx({
        [styles.active]: category.isActive,
        [styles.subCategory]: level > 0,
        [styles.category]: level === 0,
      })}
    >
      <HeaderWithArrow href={url} isOpen={isOpen} isActive={category.isActive} title={category.title} onToggle={toggleCategory} />
      {isOpen && (
        <>
          {!!category.subCategories?.length && (
            <div className={styles.subCategories}>
              {category.subCategories?.map((subCategory) => (
                <CategoryItem
                  key={subCategory.id}
                  baseUrl={url}
                  category={subCategory}
                  activeSlug={activeSlug}
                  level={level + 1}
                  type={type}
                />
              ))}
            </div>
          )}
          {!!category.articles?.length && (
            <div className={styles.articles}>
              {category.articles.map((article) => (
                <ArticleItemSidebar key={article.id} article={article} isActive={article.isActive} type={type} />
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
